import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

interface ItemList {
	driverName: string
	status: string
	timesheetDate: string
	timeSheetId: number | null
	totalServices: number
	comments: string
}

export interface TimeSheetDetailPageState {
	driver: ItemList
	driverTableId: number
}

const initialState: TimeSheetDetailPageState = {
	driver: {
		driverName: '',
		timesheetDate: '',
		totalServices: 0,
		timeSheetId: null,
		status: '',
		comments: '',
	},
	driverTableId: 0,
}

export const timesheetPageDetailSlice = createSlice({
	name: 'timesheetPageDetail',
	initialState,
	reducers: {
		addDetailsDriver: (state, action: PayloadAction<Partial<TimeSheetDetailPageState>>) => {
			Object.assign(state, action.payload)
		},
		handleDriver(state, action: PayloadAction<Partial<ItemList>>) {
			if (state.driver) {
				Object.assign(state.driver, action.payload)
			}
		},
	},
})

export const { addDetailsDriver, handleDriver } = timesheetPageDetailSlice.actions
